import {Grid} from "@mui/material";
import {useLangContext} from "shared/features/Language";
import {CustomButton} from "../../../../shared/components/Buttons/CustomButton";
import "./assemblyFooter.scss";
import {useConsumerArtApi} from "../../../art/api";
import {useCallback} from "react";
import FileSaver from "file-saver";

interface IProps {
  onClear: () => void;
  stepBack: () => void;
}

export const AssemblyFooter = ({onClear, stepBack}: IProps) => {
  const {textData} = useLangContext();
  const {downloadPDF} = useConsumerArtApi();

  const getPdfHandler = useCallback(async () => {
    try {
      const result = await downloadPDF();
      const csvFile = new Blob([result], {type: "application/pdf"});
      FileSaver.saveAs(csvFile, "YourInstruction.pdf");
    } catch (e) {
      console.error(e);
    }
  }, [downloadPDF]);

  return (
    <div className="assembly-view_footer">
      <Grid container
        sx={{
          gap: '40px',
          justifyContent: 'center',
          marginTop: { xl: '0px', lg: '45px', xs: '45px' },
        }}
      >
        <Grid item>
          <CustomButton
            color='secondary'
            width={{ lg: '250px', xs: '200px' }}
            onClick={stepBack}
          >{textData.buttonCaptionBack}</CustomButton>
        </Grid>
        <Grid item>
          <CustomButton
            width={{ lg: '250px', xs: '200px' }}
            onClick={onClear}
          >{textData.buttonCaptionClear}</CustomButton>
        </Grid>
      </Grid>
      <div className="assembly-view_footer-instruction">{textData.assemblyFooterText}</div>
      <div>
        <button className="assembly-view_footer-pdf" onClick={getPdfHandler}>
          {textData.assemblyPDFLink}
        </button>
      </div>
    </div>
  );
};
